export default {"src":"/_next/static/media/imageNullValue.8aced339.svg","height":223,"width":397,"blurWidth":0,"blurHeight":0};